import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { array, object, oneOfType, shape, string } from "prop-types";
import { PropImageField } from "../../prop-types";
import classNames from "classnames";
import { debounce } from "lodash";
import "./style.scss";

const BackgroundImage = ({ value, id, fit = "cover", theme = "black", children, className, onClick, onTransitionEnd }, ref) => {
  const rootNode = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const handleLoad = useCallback(async () => {
    if (rootNode.current && !loaded) {
      const rect = rootNode.current.getBoundingClientRect();
      if (rect.top < window.innerHeight) setLoaded(true);
    }
  }, [rootNode, loaded, value]);
  const handleClick = e => {
    onClick && onClick(e);
  };
  const onScroll = debounce(async () => {
    await handleLoad();
  }, 10);
  const rootClasses = classNames("c-background-image", theme, className);
  const rootStyle = {
    backgroundSize: fit,
    backgroundImage: value && loaded ? (value.src ? `url(${value.src})` : value.image) : null
  };
  useImperativeHandle(ref, () => {
    return {
      getEl: () => rootNode.current
    };
  });
  useEffect(() => {
    if (value?.src || value?.image) {
      handleLoad().then();
      global.addEventListener("scroll", onScroll, { passive: false });
      return () => {
        global.removeEventListener("scroll", onScroll);
      };
    }
  }, []);
  return (
    <div className={rootClasses} style={rootStyle} ref={rootNode} onClick={handleClick} onTransitionEnd={onTransitionEnd} id={id}>
      {children}
    </div>
  );
};
export default forwardRef(BackgroundImage);
BackgroundImage.propTypes = {
  value: shape(PropImageField),
  fit: string,
  theme: string,
  children: oneOfType([object, array, string])
};
